import { render, staticRenderFns } from "./AliasCreatePanel.vue?vue&type=template&id=56ee45c3&scoped=true&"
import script from "./AliasCreatePanel.vue?vue&type=script&lang=ts&"
export * from "./AliasCreatePanel.vue?vue&type=script&lang=ts&"
import style0 from "./AliasCreatePanel.vue?vue&type=style&index=0&id=56ee45c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee45c3",
  null
  
)

export default component.exports